import React from 'react';
import { ShieldCheck } from '@phosphor-icons/react';

export default function TrustBadge({ size = 'sm', className = '' }) {
  const sizes = {
    xs: { icon: 12, text: 'text-[10px]' },
    sm: { icon: 14, text: 'text-xs' },
    md: { icon: 16, text: 'text-sm' },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <span className={`inline-flex items-center gap-0.5 text-[#0000FF] ${className}`} title="Verifiziert" data-testid="trust-badge">
      <ShieldCheck size={s.icon} weight="fill" />
    </span>
  );
}
